export var RestoreJobSortField;
(function (RestoreJobSortField) {
    RestoreJobSortField["RESTORE_JOB_SORT_CREATED_TIME"] = "createdTime";
    RestoreJobSortField["RESTORE_JOB_SORT_START_TIME"] = "startTime";
    RestoreJobSortField["RESTORE_JOB_SORT_END_TIME"] = "endTime";
})(RestoreJobSortField || (RestoreJobSortField = {}));
